import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { Player } from '../../../jscaip/Player';
import { TableUtils } from '../../../jscaip/TableUtils';
import { MGPValidators } from '../../../utils/MGPValidator';
import { MancalaRules } from '../common/MancalaRules';
export class BaAwaRules extends MancalaRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Ba-awa`,
        config: {
            feedOriginalHouse: new BooleanConfig(true, MancalaRules.FEED_ORIGINAL_HOUSE),
            mustFeed: new BooleanConfig(false, MancalaRules.MUST_FEED),
            passByPlayerStore: new BooleanConfig(false, MancalaRules.PASS_BY_PLAYER_STORE),
            mustContinueDistributionAfterStore: new BooleanConfig(false, MancalaRules.MULTIPLE_SOW),
            continueLapUntilCaptureOrEmptyHouse: new BooleanConfig(true, MancalaRules.CYCLICAL_LAP),
            seedsByHouse: new NumberConfig(4, MancalaRules.SEEDS_BY_HOUSE, MGPValidators.range(1, 99)),
            width: new NumberConfig(6, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            numberOfRows: new NumberConfig(1, MancalaRules.NUMBER_OF_ROWS, MGPValidators.range(1, 99)),
            splitFinalSeedsEvenly: new BooleanConfig(false, () => $localize `Split final seeds evenly`),
        },
    }, [{
            name: () => $localize `Even Ba-awa`,
            config: {
                feedOriginalHouse: true,
                mustFeed: false,
                passByPlayerStore: false,
                mustContinueDistributionAfterStore: false,
                continueLapUntilCaptureOrEmptyHouse: true,
                seedsByHouse: 4,
                width: 6,
                numberOfRows: 1,
                splitFinalSeedsEvenly: true,
            },
        }]);
    static get() {
        if (BaAwaRules.singleton.isAbsent()) {
            BaAwaRules.singleton = MGPOptional.of(new BaAwaRules([4]));
        }
        return BaAwaRules.singleton.get();
    }
    getRulesConfigDescription() {
        return BaAwaRules.RULES_CONFIG_DESCRIPTION;
    }
    applyCapture(distributionResult) {
        const captureMap = TableUtils.copy(distributionResult.captureMap);
        const lastDrop = distributionResult.filledCoords[distributionResult.filledCoords.length - 1];
        if (distributionResult.endsUpInStore === false) {
            const lastHouseContent = distributionResult.resultingState.getPieceAt(lastDrop);
            if (this.isCapturableValue(lastHouseContent)) {
                const currentPlayer = distributionResult.resultingState.getCurrentPlayer();
                distributionResult.capturedSum += lastHouseContent;
                captureMap[lastDrop.y][lastDrop.x] += lastHouseContent;
                distributionResult.resultingState =
                    distributionResult.resultingState.capture(currentPlayer, lastDrop);
            }
        }
        return {
            capturedSum: distributionResult.capturedSum,
            captureMap,
            resultingState: distributionResult.resultingState,
        };
    }
    getDropResult(seedsInHand, state, coord) {
        let resultingState = state.feed(coord);
        const previousValue = resultingState.getPieceAt(coord);
        const captureMap = TableUtils.create(state.getWidth(), state.getHeight(), 0);
        if (previousValue === 4 && seedsInHand > 1) {
            captureMap[coord.y][coord.x] = 4;
            const houseOwner = Player.of(coord.y).getOpponent();
            resultingState = resultingState.capture(houseOwner, coord);
            return { capturedSum: 4, captureMap, resultingState };
        }
        else {
            return { capturedSum: 0, captureMap, resultingState };
        }
    }
    mustMonsoon(postCaptureState, config) {
        const mustMonsoon = super.mustMonsoon(postCaptureState, config);
        if (mustMonsoon.length > 0) {
            return mustMonsoon;
        }
        else {
            if (postCaptureState.getTotalRemainingSeeds() <= 8) {
                if (config.splitFinalSeedsEvenly) {
                    return [Player.ZERO, Player.ONE];
                }
                else {
                    return [Player.ZERO];
                }
            }
            else {
                return [];
            }
        }
    }
}
